import React, { useEffect, useCallback } from "react";
import * as Scrivito from "scrivito";
import { Checkbox } from "components/Inputs";
import { useProjectUIStore } from "stores/projectStore";
import { useTranslate } from "hooks";

export const ToggleShowPictures = Scrivito.connect(() => {
  const translate = useTranslate();
  const showProductPictures = useProjectUIStore(
    (state) => state.showProductPictures,
  );
  const setShowProductPictures = useProjectUIStore(
    (state) => state.setShowProductPictures,
  );

  useEffect(() => {
    const storedValue = sessionStorage.getItem("showProductPictures");
    if (storedValue !== null) {
      setShowProductPictures(storedValue === "true");
    }
  }, [setShowProductPictures]);

  const handleChange = useCallback(() => {
    setShowProductPictures((prev) => {
      const newValue = !prev;
      sessionStorage.setItem("showProductPictures", newValue.toString());
      return newValue;
    });
  }, [setShowProductPictures]);

  return (
    <div className="d-flex gap-2">
      <Checkbox
        checked={showProductPictures}
        onChange={handleChange}
        wrapperClassName="cursor-pointer"
      />
      {translate("PROJECT_STRUCTURE_SHOW_PRODUCT_PICTURES")}
    </div>
  );
});
